import React from "react";
import { lineSpinner } from 'ldrs';

lineSpinner.register()

const LoadingRaport = () => {
    return <div
        style={{
            top: 0,
            left: 0,
            zIndex: 999,
            color: "#333",
            width: "100%",
            height: "100%",
            display: "flex",
            fontSize: "1.5rem",
            fontWeight: "bold",
            position: "absolute",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(255, 255, 255, .9)",
        }}
    >
        <l-line-spinner
            size="75"
            speed="1"
            stroke="3"
            color="grey"
        ></l-line-spinner>
    </div>
}

export default LoadingRaport;